import React, { useState } from 'react';
import { Menu, X, Phone, Mail, MapPin } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (id) => {
    // If we're on the About page, navigate to home first
    if (location.pathname === '/about') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMenuOpen(false);
  };

  const navigateToAbout = () => {
    navigate('/about');
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md shadow-sm">
      {/* Top bar */}
      <div className="bg-gradient-to-r from-[#1565C0] to-[#0D47A1] text-white py-2">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap justify-center md:justify-between items-center text-sm gap-4">
            <div className="flex items-center gap-4">
              <a href="tel:9052808055" className="flex items-center gap-1 hover:text-[#8BC34A] transition-colors">
                <Phone size={14} />
                <span>+91 905-280-8055</span>
              </a>
              <a href="mailto:info@thevisaspot.com" className="flex items-center gap-1 hover:text-[#8BC34A] transition-colors">
                <Mail size={14} />
                <span>info@thevisaspot.com</span>
              </a>
            </div>
            <div className="flex items-center gap-1">
              <MapPin size={14} />
              <span>Serving clients worldwide</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main navigation */}
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_d7a39a59-63ba-4bd9-b746-de38b35bd039/artifacts/rsx786qh_WhatsApp%20Image%202026-04-08%20at%2017.50.03.jpeg" 
              alt="Visaspot" 
              className="h-12 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-[#1565C0] font-medium transition-colors">
              Home
            </button>
            <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-[#1565C0] font-medium transition-colors">
              Services
            </button>
            <button onClick={() => scrollToSection('countries')} className="text-gray-700 hover:text-[#1565C0] font-medium transition-colors">
              Countries
            </button>
            <button onClick={navigateToAbout} className="text-gray-700 hover:text-[#1565C0] font-medium transition-colors">
              About
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-[#1565C0] font-medium transition-colors">
              Contact
            </button>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Button 
              onClick={() => scrollToSection('consultation')}
              className="bg-gradient-to-r from-[#FF7043] to-[#F4511E] hover:from-[#F4511E] hover:to-[#FF7043] text-white px-6"
            >
              Free Consultation
            </Button>
          </div>

          {/* Mobile menu button */}
          <button 
            className="md:hidden text-gray-700"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
          </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t">
            <nav className="flex flex-col gap-4">
              <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-[#1565C0] font-medium transition-colors text-left">
                Home
              </button>
              <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-[#1565C0] font-medium transition-colors text-left">
                Services
              </button>
              <button onClick={() => scrollToSection('countries')} className="text-gray-700 hover:text-[#1565C0] font-medium transition-colors text-left">
                Countries
              </button>
              <button onClick={navigateToAbout} className="text-gray-700 hover:text-[#1565C0] font-medium transition-colors text-left">
                About
              </button>
              <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-[#1565C0] font-medium transition-colors text-left">
                Contact
              </button>
              <Button 
                onClick={() => scrollToSection('consultation')}
                className="bg-gradient-to-r from-[#FF7043] to-[#F4511E] hover:from-[#F4511E] hover:to-[#FF7043] text-white w-full"
              >
                Free Consultation
              </Button>
              </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
